import React from "react"

export const convertNewLines = (s: string) => {
    const parts = s.split("\n")
    return parts.map((p, i) => (
        <React.Fragment key={i}>{p}<br/></React.Fragment>
    ))
}
